import { render } from "./ModalNotificationComponent.vue?vue&type=template&id=177bc45a"
import script from "./ModalNotificationComponent.vue?vue&type=script&lang=js"
export * from "./ModalNotificationComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__